import React, { useEffect } from 'react'
import { HashRouter as Router, Route, Routes } from 'react-router-dom'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import HomePage from './components/HomePage'
import ServicePage from './components/ServicePage'
import AboutPage from './components/AboutUs'
import ContactPage from './components/ContactUs'
import WhyChooseUs from './components/WhyToChose'
import RentalPackages from './components/RentalPackages'
import AOS from 'aos'
import 'aos/dist/aos.css'

function App() {
  useEffect(() => {
    AOS.init({
      duration: 600,
      once: false,
      easing: 'ease-in-out',
    })
  }, [])

  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/service" element={<ServicePage />} />
        <Route path="/aboutus" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/rental-packages" element={<RentalPackages />} />
        <Route path="/why-choose-us" element={<WhyChooseUs />} />
      </Routes>
      <Footer />
    </Router>
  )
}

export default App
